import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Megaphone, Loader2, ExternalLink, Check, X, Share2 } from "lucide-react";

const KIND_LABEL = {
  meta_ads: "Meta hirdetés",
  facebook_crosspost: "Facebook Marketplace + csoportok",
};

function requestKind(r) {
  return r.kind || "meta_ads";
}

export function AdminAdRequests() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/ad-requests");
      setRows(r.data.requests || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try {
      await api.post(`/admin/ad-requests/${id}/status`, { status });
      toast.success("Státusz frissítve");
      load();
    } catch (e) {
      toast.error("Nem sikerült");
    }
  };

  if (loading) return <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 text-electric animate-spin" /></div>;
  if (rows.length === 0) return <p data-testid="ad-requests-empty" className="text-slate-400 text-sm">Nincs megosztási vagy hirdetési kérés.</p>;

  return (
    <div className="space-y-3" data-testid="admin-ad-requests">
      {rows.map((r) => {
        const kind = requestKind(r);
        const KindIcon = kind === "facebook_crosspost" ? Share2 : Megaphone;
        return (
        <div key={r.id} data-testid={`ad-request-${r.id}`} className="glass rounded-2xl p-4 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-start gap-3 min-w-0 flex-1">
            <div className="w-10 h-10 rounded-xl bg-amber-500/15 flex items-center justify-center shrink-0">
              <KindIcon className="w-4 h-4 text-amber-400" strokeWidth={1.5} />
            </div>
            <div className="min-w-0">
              <div className="text-[10px] uppercase tracking-widest text-slate-500 mb-0.5">{KIND_LABEL[kind] || kind}</div>
              <div className="font-medium">{r.user?.name || "Eladó"} · <span className="text-slate-400 font-normal">{r.user?.email}</span></div>
              <div className="text-sm text-slate-300">
                {r.car ? `${r.car.make} ${r.car.model} (${r.car.year})` : "—"}
                {r.car?.id && (
                  <a href={r.car.slug ? `/auto/${r.car.slug}` : `/auto/${r.car.id}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 ml-2 text-electric hover:text-electric-light text-xs">
                    <ExternalLink className="w-3 h-3" /> Megnyitás
                  </a>
                )}
              </div>
              <div className="text-xs text-slate-500 mt-1">
                Kérés: {new Date(r.requested_at).toLocaleString("hu-HU")}
                {r.until ? ` · Aktív: ${new Date(r.until).toLocaleDateString("hu-HU")}-ig` : ""}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span data-testid={`ad-request-status-${r.id}`} className={`text-[11px] uppercase tracking-widest px-2.5 py-1 rounded-full ${
              r.status === "processed" ? "bg-emerald-500/15 text-emerald-300 border border-emerald-400/30"
                : r.status === "cancelled" ? "bg-red-500/15 text-red-300 border border-red-400/30"
                : "bg-amber-500/15 text-amber-300 border border-amber-400/30"
            }`}>{r.status || "pending"}</span>
            {r.status !== "processed" && (
              <button data-testid={`ad-request-mark-processed-${r.id}`} onClick={() => setStatus(r.id, "processed")} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-emerald-500/15 text-emerald-300 hover:bg-emerald-500/25 text-xs">
                <Check className="w-3 h-3" /> Kezelve
              </button>
            )}
            {r.status !== "cancelled" && (
              <button data-testid={`ad-request-cancel-${r.id}`} onClick={() => setStatus(r.id, "cancelled")} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-red-500/10 text-red-300 hover:bg-red-500/20 text-xs">
                <X className="w-3 h-3" /> Elutasítás
              </button>
            )}
          </div>
        </div>
      );})}
    </div>
  );
}
